import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewChild,
  Renderer2,
  EventEmitter,
  Output
} from '@angular/core';
import {User} from 'projects/core/src/lib/login/data/user';
import {TimeCardService} from '../../../data/time-card.service';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {AppStateStore} from 'projects/desktop/src/app/data/app-state.store';
import {TimeCardsStore} from '../../../data/time-cards.store';
import {TimeCardsQuery} from '../../../data/time-cards.query';
import {PunchWidgetDialogComponent} from '../punch-widget-dialog.component';
import {interval, timer, Subscription, Subject} from 'rxjs';
import {map, takeUntil} from 'rxjs/operators';

import * as moment from 'moment';
import {ProjectService} from '../../../../project-misc/data/project/project.service';
import {Project} from '../../../../project-misc/data/project/project';
import {TimeCard, TimeCardType} from '../../../data/time-card';
import {environment} from 'projects/mobile/src/environments/environment';
import {OverlayPanel} from 'primeng/overlaypanel';
import {MvcExceptionResponse} from 'projects/core/src/lib/core/data/mvc-exception-response';
import {MatSnackBarRef, SimpleSnackBar, MatSnackBar} from '@angular/material/snack-bar';
import {MatDialogRef, MatDialog} from '@angular/material/dialog';
import {
  TimesheetEditDialogComponent
} from 'projects/desktop/src/app/modules/timesheets/view/timesheet-edit-dialog/timesheet-edit-dialog.component';
import {CustomCoordinates} from '../../../data/custom-coordinates';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {MiscSnackBarService} from '../../../../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {LocalStorage} from 'ngx-webstorage';
import {UserProjectsHistory} from '../../../data/userProjectsHistory';

@Component({
  selector: 'app-day-total',
  templateUrl: './day-total.component.html',
  styleUrls: ['./day-total.component.scss']
})
@RxJSUnsubscribe
export class DayTotalComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

  @ViewChild('switchOp', {static: true})
  switchOp: OverlayPanel

  currentUser: User;
  punchedIn: boolean;

  lastCard: TimeCard;

  @ViewChild('pie', {static: true})
  pieEl: ElementRef;

  @ViewChild('pieback', {static: true})
  piebackEl: ElementRef;

  totalTime = '';
  circlePercent = 0;

  isLower: boolean;
  rotation = '';

  projects: Project[];

  choosenProject: Project;

  @Output()
  showProjects = new EventEmitter<void>();

  outTime$ = this.timeCardsQuery.lastTimeCard
    .pipe(
      map(lastCard => lastCard && lastCard.startTime ? moment(lastCard.startTime).format('hh:mm A') : '')
    )

  projectsLoading = false;

  intervalSub: Subscription;

  lastCardTime: string;

  userCoordinates: CustomCoordinates;

  activeSnackBar: MatSnackBarRef<SimpleSnackBar>
  showAnimation = false;

  chooseProjSubj: Subscription;
  changerProjSubj: Subscription;

  unResolvedCards: TimeCard[];

  constructor(
    private snackBar: MatSnackBar,
    private renderer: Renderer2,
    private timeCardService: TimeCardService,
    private projectService: ProjectService,
    protected appStateQuery: AppStateQuery,
    protected appStateStore: AppStateStore,
    protected timeCardsStore: TimeCardsStore,
    protected timeCardsQuery: TimeCardsQuery,
    private dialogRef: MatDialogRef<PunchWidgetDialogComponent>,
    protected dialog: MatDialog,
    protected miscSnackBarService: MiscSnackBarService
  ) {
  }

  ngOnInit() {
    // this.openSnackBar('Limit of breaks');


    this.timeCardService.getLastJob().subscribe(job => {
      this.choosenProject = job
    })

    this.getGeolocation();

    this.timeCardsQuery.punchedIn$
      .pipe(
        takeUntil(this.getUnsubFromAllSubs())
      )
      .subscribe(punchStatus => this.punchedIn = punchStatus)
    this.timeCardsQuery.lastTimeCard
      .pipe(
        takeUntil(this.getUnsubFromAllSubs())
      )
      .subscribe(lastCard => {
        this.lastCard = lastCard
        if (this.lastCard && this.lastCard.job) {
          if (this.punchedIn) {
            this.choosenProject = this.lastCard.job;
          }
        }
        this.countTimeForLastCard();
      })
    this.appStateQuery.currentUser$
      .pipe(
        takeUntil(this.getUnsubFromAllSubs())
      )
      .subscribe(currentUser => this.currentUser = currentUser)


    this.projectsLoading = true;
    this.projectService.getLastProjects().subscribe(projects => {
      this.projects = projects
      this.projectsLoading = false;
    })

    timer(0, 30000)
      .pipe(
        takeUntil(this.getUnsubFromAllSubs())
      )
      .subscribe(() => {
        this.getTotalTime()
      })

    timer(0, 1000)
      .pipe(
        takeUntil(this.getUnsubFromAllSubs())
      )
      .subscribe(() => {
        this.countTimeForLastCard()
      })

    this.subToChoosenproject()
    this.subToChangedProject()

    if (this.currentUser.timeCardsClosedBySystem) {
      this.getUnclosedTimeCards();
    }
  }


  countTimeForLastCard() {
    if (this.lastCard) {
      this.timer();
    }
  }

  timer() {
    if (!this.intervalSub) {

      if (this.punchedIn) {

        this.intervalSub = interval(1000)
          .pipe(
            takeUntil(this.getUnsubFromAllSubs())
          ).subscribe(() => {
            this.lastCardTime = this.countHandM((moment().diff(this.lastCard.startTime, 'seconds')))
          })
      }
    }
  }

  countHandM(seconds: number) {
    const totalMinutes = Math.trunc(seconds / 60);

    const totalHours = Math.trunc(totalMinutes / 60)
    const pastMinutes = Math.trunc(totalMinutes - totalHours * 60)

    const pastSeconds = Math.trunc(seconds - totalMinutes * 60)
    return totalHours + 'h ' + pastMinutes + 'm ' + pastSeconds + 's'
  }

  getTotalTime() {
    this.timeCardsQuery.todayTotalTime$.subscribe(time => {
      const totalHours = Math.trunc(time / 60)
      const totalMinutes = Math.trunc(time - totalHours * 60)
      this.totalTime = totalHours + 'h ' + totalMinutes + 'm'
      this.circlePercent = Math.trunc(Math.trunc(100 / (480 / time)))

      this.circlePercent = 100 - this.circlePercent;

      if (this.circlePercent > -environment.timeCard.maxOvertimePercent && this.circlePercent < 0) {
        this.circlePercent = 0;
      }

      this.countPercent();
    })

  }

  countPercent() {
    if (this.circlePercent < -1) {
      this.renderer.addClass(this.pieEl.nativeElement, 'overtime')
      this.renderer.addClass(this.piebackEl.nativeElement, 'overtime')
    } else if (this.circlePercent >= 0 && this.circlePercent <= 50) {
      this.rotation = ((100 - (50 - this.circlePercent)) / 100 * 360 * -1) + 'deg';
      this.isLower = true;

    } else {
      this.rotation = ((100 - this.circlePercent) / 100 * 360) + 'deg';
      this.isLower = false;
    }

    this.pieEl.nativeElement.style.setProperty('--load-progress', this.rotation)
    this.piebackEl.nativeElement.style.setProperty('--load-progress', this.rotation)
  }

  togglePunchStatus() {
    this.showAnimation = true;
    if (!this.choosenProject) {
      this.openSnackBar('First select a project')
      return;
    }

    if (!this.userCoordinates) {
      this.openSnackBar('You should share your location or use shop Wi-Fi')

      this.getGeolocation();

      return;
    }

    this.timeCardsStore.updatePunchStatus(!this.punchedIn);
    if (this.punchedIn) {

      this.timeCardService.punchIn(
        this.userCoordinates.latitude,
        this.userCoordinates.longitude,
        'WORK',
        this.choosenProject &&
        this.choosenProject.id
      ).subscribe(() => {
          timer(700).subscribe(() => {
            this.dialogRef.close()
          })
        },
        error => {
          if (error instanceof MvcExceptionResponse) {
            if (error.type === 'time_card.TimeCardException') {
              this.openSnackBar(error.message)
            }
          }
        })

    } else {
      this.timeCardService.punchOut(this.userCoordinates.latitude, this.userCoordinates.longitude).subscribe()
    }

  }

  takeABreak(breakType: TimeCardType) {
    this.timeCardService.startBreak(this.userCoordinates.latitude, this.userCoordinates.longitude, breakType)
      .subscribe(() => {
        },
        error => {
          if (error instanceof MvcExceptionResponse) {
            if (error.type === 'time_card.TimeCardException') {
              this.openSnackBar(error.message)
            }
          }
        })
  }

  switchProject() {
    this.showProjects.emit();
  }

  subToChoosenproject() {
    this.chooseProjSubj = this.timeCardsQuery.chosenProject$.subscribe(project => {
      this.choosenProject = project;
    })
  }

  subToChangedProject() {
    this.changerProjSubj = this.timeCardService.projectChanger.subscribe(proj => {
      if (this.punchedIn || (this.lastCard.type === 'PAID_BREAK' || this.lastCard.type === 'UNPAID_BREAK')) {
        this.timeCardService.punchIn(this.userCoordinates.latitude, this.userCoordinates.longitude, 'WORK', proj && proj.id).subscribe(() => {
        })
      }
    })
  }


  openSnackBar(message: string) {
    if (this.activeSnackBar) {
      this.activeSnackBar.dismiss();
    }

    this.activeSnackBar = this.snackBar.open(message, '', {
      duration: 5000,
      panelClass: 'punch-widget-snackbar',
      verticalPosition: 'top',
    });
  }

  getGeolocation() {
    this.timeCardService.isUserInShop().subscribe(coords => {
      if (coords.latitude !== 0 || coords.longitude !== 0) {
        this.userCoordinates = coords
      } else {
        navigator.geolocation.getCurrentPosition(
          position => {
            this.userCoordinates = position.coords
          },
          error => {
            if (error.code === error.PERMISSION_DENIED) {
              this.openSnackBar('Geolocation should be allowed')
            }
          });
      }
    })
  }

  addSheet() {
    const dialogRef = this.dialog.open(TimesheetEditDialogComponent, {
      data: {buttonLabel: 'Add'},
      disableClose: true,
      panelClass: 'time-sheet-edit-dialog'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.timeCardService.getTodayCards().subscribe(() => {

        const today = moment().format('YYYY-MM-DD')
        this.timeCardService.getTodayTotalTime(this.currentUser.id, today, today).subscribe(() => {
        })
      })
    });
  }

  ngOnDestroy() {
    this.chooseProjSubj.unsubscribe()
    this.changerProjSubj.unsubscribe()
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }


  getUnclosedTimeCards() {
    this.timeCardService.getClosedBySystemCards(this.currentUser.id).subscribe(cards => {
      this.unResolvedCards = cards

      if (this.unResolvedCards.length) {
        // this.miscSnackBarService.openWarningSnackBar('You have an unresolved time card')
        this.editUnresolvedTimeCard(this.unResolvedCards[0])
      }
    })
  }

  editUnresolvedTimeCard(timeCard) {
    const dialogRef = this.dialog.open(TimesheetEditDialogComponent, {
      data: {
        timeCard: {
          id: timeCard.id,
          startTime: timeCard.startTime,
          finishTime: timeCard.finishTime
        },
        buttonLabel: 'Save',
        fromKiosk: true
      },
      disableClose: false,
      panelClass: 'time-sheet-edit-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.unResolvedCards.shift();

        if (this.unResolvedCards.length === 0) {
          this.currentUser.timeCardsClosedBySystem = false;
        }

        this.miscSnackBarService.openSuccessSnackBar('Success!')
      }
    });
  }

  editUnresolvedTimeCardButton() {
    this.editUnresolvedTimeCard(this.unResolvedCards[0])
  }
}
